<template>
    <v-layout>
        <v-flex>
            <v-sheet>
                <!-- now is normally calculated by itself, but to keep the calendar in this date range to view events -->
                <v-toolbar flat>
                    <v-btn icon @click="prev">
                        <v-icon>chevron_left</v-icon>
                    </v-btn>

                    <v-toolbar-title class="mx-3">
                        {{ title }}
                    </v-toolbar-title>

                    <v-btn icon @click="next">
                        <v-icon>chevron_right</v-icon>
                    </v-btn>

                    <v-spacer></v-spacer>
                    <v-text-field v-model="task" 
                    :placeholder="$t('lang.task.taskname')"
                     style="margin:5px"
                     @keyup.enter="getData"/>

                    <v-autocomplete :placeholder="$t('lang.files.manageId')" single-line hide-details
                          small clearable browser-autocomplete="on"
                          @change="getData"
                          v-model="manageId"
                          :items="lstUsers"
                          item-text="name" item-value="id" style="margin:-18px 5px 0px 5px;"/>

                    <v-btn-toggle v-model="viewMode" mandatory>
                        <v-btn value="month">Month</v-btn>
                        <v-btn value="week">Week</v-btn>
                    </v-btn-toggle>
                </v-toolbar>
                <v-calendar ref="calendar" :end="endStr" :value="endStr" color="primary" :type="viewMode">
                    <!-- the events at the top (all-day) -->
                    <template v-slot:dayHeader="{ date }">
                        <template v-for="event in eventsMap[date]">
                            <!-- all day events don't have time -->
                            <v-tooltip
                                :key="event.id"
                                bottom
                                max-width="400">
                                <template v-slot:activator="{ on }">
                                    <div v-ripple class="my-event" v-on="on" v-html="event.title" @click="openEvent(event)"/>
                                </template>
                                <div>
                                    <div><b>Nhãn:</b> {{ event.ref.trademark }}</div>
                                    <div><b>Số đơn:</b> {{ event.ref.Application_Number }}</div>
                                    <div><b>Công việc:</b> {{ event.ref.task }}</div>
                                </div>
                            </v-tooltip>
                        </template>
                    </template>
                    <!-- the events at the bottom (timed) -->
                    <template v-slot:dayBody="{ date, timeToY, minutesToPixels }">
                        <template v-for="event in eventsMap[date]">
                            <!-- timed events -->
                            <div v-if="event.time" :key="event.title"
                                :style="{ top: timeToY(event.time) + 'px', height: minutesToPixels(event.duration) + 'px' }"
                                class="my-event with-time" @click="open(event)" v-html="event.title"></div>
                        </template>
                    </template>
                    <template v-slot:day="{ date }">
                        <template v-for="event in eventsMap[date]">
                            <!--v-menu v-model="event.open" :key="event.title" full-width offset-x>
                                <template v-slot:activator="{ on }">
                                    <div v-if="!event.time" v-ripple class="my-event" v-on="on" v-html="event.title">
                                    </div>
                                </template>
                            </v-menu-->
                            <v-tooltip
                                :key="event.id"
                                bottom
                                max-width="400">
                                <template v-slot:activator="{ on }">
                                    <div v-ripple class="my-event" v-on="on" v-html="event.title"  @click="openEvent(event)"/>
                                </template>
                                <div>
                                    <div><b>Nhãn:</b> {{ event.ref.trademark }}</div>
                                    <div><b>Số đơn:</b> {{ event.ref.Application_Number }}</div>
                                    <div><b>Công việc:</b> {{ event.ref.task }}</div>
                                </div>
                            </v-tooltip>
                        </template>
                    </template>

                </v-calendar>
            </v-sheet>
        </v-flex>
    </v-layout>
</template>

<script>
import axios from "axios";
import moment from 'moment';

export default {
    name: 'file-due-date',
    components: {
    },
    data: () => {
        return {
            start: new Date(),
            end: (new Date()).setDate(new Date().getDate() + 7),
            viewMode: "month",
            lstFile: [],
            lstRequest: [],
            lstUsers:[],
            manageId:null,
            task:null,
            events: [
                {
                    title: 'Weekly Meeting',
                    date: '2026-06-09',
                    time: '09:00',
                    duration: 45
                },
                {
                    title: 'Thomas\' Birthday',
                    date: '2026-06-08'
                },
                {
                    title: 'Mash Potatoes',
                    date: '2026-06-07',
                    time: '12:30',
                    duration: 180
                }
            ]

        }
    },
    created() {
        this.initData();
        this.initStartAndEndDay();
    },

    mounted() {
        this.$refs.calendar.scrollToTime('08:00');
    },

    methods: {
        initData(){
            axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/active-user", {}).then(
                data => {
                    this.lstUsers= data.items;
                }
            )
        },

        initStartAndEndDay() {
            if (this.viewMode === "week") {
                const today = new Date();
                today.setHours(0,0,0,0);
                const distanceToSunday = today.getDay();
                const firstOfWeek = new Date(today);
                firstOfWeek.setDate(today.getDate() - distanceToSunday);
                this.start = new Date(firstOfWeek);

                const distanceToSaturday = 6 - today.getDay();
                // Create the end of the week date
                const endOfWeek = new Date(today);
                endOfWeek.setDate(today.getDate() + distanceToSaturday);
                this.end = new Date(endOfWeek);
            } else {
                const today = new Date();
                const year = today.getFullYear();
                const month = today.getMonth(); // Tháng trong JS chạy từ 0 đến 11

                // 1. Ngày đầu tiên của tháng (Luôn là ngày 1)
                const firstDayOfMonth = new Date(year, month, 1);
                this.start = new Date(firstDayOfMonth);

                // 2. Ngày cuối cùng của tháng (Ngày 0 của tháng sau chính là ngày cuối tháng này)
                const lastDayOfMonth = new Date(year, month + 1, 0);
                this.end = new Date(lastDayOfMonth);

            }
            this.getData();
        },

        prev() {
            if (this.viewMode === "week") {
                this.start = new Date(this.start);
                this.start.setDate(this.start.getDate() - 7);
                this.end = new Date(this.start);
                this.end.setDate(this.start.getDate() + 6);
            } else {
                this.start = new Date(this.start);
                this.start.setMonth(this.start.getMonth() - 1);
                const year = this.start.getFullYear();
                const month = this.start.getMonth(); // Tháng trong JS chạy từ 0 đến 11
                this.end = new Date(this.end);
                this.end = new Date(year, month + 1, 0);
            };
            this.getData();
        },

        next() {
            if (this.viewMode === "week") {
                this.start = new Date(this.start);
                this.start.setDate(this.start.getDate() + 7);
                this.end = new Date(this.start);
                this.end.setDate(this.start.getDate() + 6);
            } else {
                this.start = new Date(this.start);
                this.start.setMonth(this.start.getMonth() + 1);
                const year = this.start.getFullYear();
                const month = this.start.getMonth(); // Tháng trong JS chạy từ 0 đến 11
                this.end = new Date(year, month + 1, 0);
                console.log(this.start,this.end);
            };
            this.getData();

        },

        getData() {
            this.getFileData();
            //this.getRequestData();
        },

        getFileData() {
            let payload ={
                dueDateRange: { 'end': this.end, 'start': this.start, name: 'dueDate' }
            }
            console.log(this.task,this.manageId);
            if(this.task){
                payload['task'] = this.task;
            }
            if(this.manageId){
                payload['manageId'] = this.manageId;
            }
            axios.post(process.env.VUE_APP_API_URL + "/files/search?pageSize=-1&page=-1&sortField=dueDate",payload ).then(
                data => {
                    this.lstFile = data.items;
                }
            )
        },

        getRequestData() {
            axios.post(process.env.VUE_APP_API_URL + "/request/search?pageSize=-1&page=-1&sortField=dueDate", { dueDateRange: { 'end': this.end, 'start': this.start, name: 'dueDate' } }).then(
                data => {
                    this.lstRequest = data.items;
                }
            )
        },

        openEvent(event){
            window.open("#/files/view/" + event.id, '_blank');
        }

    },
    watch: {
        viewMode() {
            this.initStartAndEndDay();
        },
    },
    computed: {
        // convert the list of events into a map of lists keyed by date
        eventsMap() {
            const map = {}
            //this.events.forEach(e => (map[e.date] = map[e.date] || []).push(e));
            this.lstFile.forEach(e => {
                //console.log(e.dueDate);
                let key = moment(e.dueDate).format('yyyy-MM-DD');
                let time = moment(e.dueDate).format('HH:mm');
                console.log(time);
                if (time === "00:00") {
                    time = null;
                }
                //console.log(key);
                let ob = {
                    title: e.trademark+"<br/>" +e.Application_Number,
                    date: key,
                    id: e.fileId,
                    type: "FILE",
                    time: time,
                    duration: 60,
                    ref:e
                }
                if (map[key]) {
                    map[key].push(ob);
                } else {
                    map[key] = [ob];
                }

                //map[key] = (map[key] || []).push(ob)
            });
            console.log(map);
            //this.lstRequest.forEach(e=>(map[e.dueDate] = map[e.dueDate] || []).push(e));
            return map
        },
        title() {
            if (this.viewMode === "week") {
                return "Tuần " + moment(this.start).format("DD/MM/yyyy") + "-" + moment(this.end).format("DD/MM/yyyy");
            } else {
                return "Tháng " + (this.start.getMonth() + 1) + "/" + this.start.getFullYear();
            }
        },

        endStr() {
            //this.end = (new Date()).setDate(new Date().getDate()+7);
            let endDate = new Date(this.end);
            if(this.viewMode === "month" && this.end.getDate() === 1){
                endDate = new Date(this.end);
                this.end.setMonth(this.end.getMonth() + 1);
            } 
            let str = moment(endDate).format("yyyy-MM-DD");
            return str;
        }
    },
    destroyed() {
    }
}
</script>